export default "__VITE_ASSET__99c57cdb__"